<div class="table-container">
  <app-loading-spinner
    *ngIf="loading"
    message="Loading invocations..."
  ></app-loading-spinner>

  <div *ngIf="!loading && invocations.length === 0" class="no-data">
    <mat-icon>inbox</mat-icon>
    <p>No invocations found</p>
  </div>

  <table
    mat-table
    [dataSource]="dataSource"
    matSort
    [matSortActive]="sortBy"
    [matSortDirection]="sortDirection"
    matSortDisableClear
    (matSortChange)="onSortChange($event)"
    *ngIf="!loading && invocations.length > 0"
    class="invocations-table"
  >
    <!-- Date/Time Column -->
    <ng-container matColumnDef="createdAt">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Date/Time</th>
      <td mat-cell *matCellDef="let row">
        {{ row.createdAt | dateTime }}
      </td>
    </ng-container>

    <!-- Phone Number Column -->
    <ng-container matColumnDef="phoneNumber">
      <th mat-header-cell *matHeaderCellDef>Phone Number</th>
      <td mat-cell *matCellDef="let row">
        {{ row.phoneNumber | phoneNumber }}
      </td>
    </ng-container>

    <!-- Result Column -->
    <ng-container matColumnDef="result">
      <th mat-header-cell *matHeaderCellDef>Result</th>
      <td mat-cell *matCellDef="let row">
        <span class="chip" [ngClass]="getResultClass(row.result)">
          {{ formatResult(row.result) }}
        </span>
      </td>
    </ng-container>

    <!-- Billing Entity Column -->
    <ng-container matColumnDef="billingEntityId">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Billing Entity</th>
      <td mat-cell *matCellDef="let row">
        {{ row.billingEntityId }}
      </td>
    </ng-container>

    <!-- Agent Column -->
    <ng-container matColumnDef="agentId">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Agent</th>
      <td mat-cell *matCellDef="let row">
        {{ row.agentId }}
      </td>
    </ng-container>

    <!-- Duration Column -->
    <ng-container matColumnDef="durationMs">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Duration</th>
      <td mat-cell *matCellDef="let row">
        {{ row.durationMs | duration }}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: displayedColumns"
      (click)="onRowClick(row)"
      class="clickable-row"
    ></tr>
  </table>

  <mat-paginator
    *ngIf="pagination"
    [length]="pagination.totalItems"
    [pageSize]="pagination.pageSize"
    [pageIndex]="pagination.page - 1"
    [pageSizeOptions]="[10, 25, 50, 100]"
    (page)="onPageChange($event)"
    showFirstLastButtons
  >
  </mat-paginator>
</div>
